import React from 'react';
import { useProductQuantity } from '../hooks/useProductQuantity';

type QuantitySelectorContainerProps = { children: React.ReactNode };

const QuantitySelectorContainer = ({ children }: QuantitySelectorContainerProps) => {
	const { blockClass, componentId } = useProductQuantity();

	const renderClass = () => blockClass && `vtex-product-quantity-1-x-quantitySelectorContainer--${blockClass}`;

	return (
		<div
			data-selection={componentId}
			className={`quantitySelectorContainer quantitySelectorContainer--${blockClass} vtex-product-quantity-1-x-quantitySelectorContainer ${renderClass()} flex flex-column mb4`}
		>
			{children}
		</div>
	);
};

export default QuantitySelectorContainer;
